import { createReducer, on } from '@ngrx/store';
import { GroupApiActions } from './group.actions';
import { initialState, adapter } from './group.state';

export const groupsReducer = createReducer(
  initialState,
  on(GroupApiActions.groupsLoaded, (state, { groups }) => adapter.setAll(groups, state)),
  on(GroupApiActions.groupDeleted, (state, { group }) => adapter.removeOne(group.id, state)),
  on(GroupApiActions.groupAdded, (state, { group }) => adapter.addOne(group, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectGroupIds = selectIds;

export const selectGroupEntities = selectEntities;

export const selectAllGroups = selectAll;
